import React from "react";
import { useSelector } from "react-redux";
import ActionButton from "@components/actionButton";
import { downloadFile } from "@utils/helpers/downloadHelper";

const DocumentLink = ({ className, activeDocumentType, onClick, buttonText }) => {
  const { pdfUrlData } = useSelector((state) => state.esign);
  const documentBlobType = activeDocumentType.name === "Contract" ? pdfUrlData.contract : pdfUrlData.repayment;
  
  const downloadAndClick = () => {
    downloadFile(documentBlobType, activeDocumentType.name);
    onClick && onClick();
  };

  return (
    <ActionButton className={className} type="button" onClick={downloadAndClick}>
      {buttonText}
    </ActionButton>
  );
};

export default DocumentLink;
